<iframe
    width="100%"
    height="400"
    scrolling="no"
    [src]="url | safe"
    frameborder="0"
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    allowfullscreen="true"
>
    <a [href]="url | safe">{{ 'web.stream_download' | translate }}</a>
</iframe>
